import { cubicCoordinates } from "easing-coordinates";
import { mix } from "motion";

function round(number: number, precision = 0) {
  return +number.toFixed(precision);
}

type ColorStop = string | { color: string; at?: number };

function normalizeColorStop(stop: ColorStop, defaultPosition: number) {
  if (typeof stop === "string") {
    return { color: stop, at: defaultPosition };
  }
  return { color: stop.color, at: stop.at ?? defaultPosition };
}

// Based on https://larsenwork.com/easing-gradients/
export function easedGradientStops(
  from: ColorStop,
  to: ColorStop,
  {
    steps = 15,
    ease = [0.42, 0, 0.58, 1],
  }: { steps?: number; ease?: [x1: number, y1: number, x2: number, y2: number] } = {},
) {
  const fromStop = normalizeColorStop(from, 0);
  const toStop = normalizeColorStop(to, 100);

  const coords = cubicCoordinates(...ease, steps);
  const mixer = mix<string>(fromStop.color, toStop.color);
  const range = toStop.at - fromStop.at;

  return coords
    .map(coord => {
      const position = fromStop.at + coord.x * range;
      return `${mixer(coord.y)} ${round(position, 2)}%`;
    })
    .join(", ");
}
